<template>

  <v-content style="padding-top: 120px;">


    <div class="flexiapp-bg-header-container"></div>

        <v-tabs 
        centered 
        grow 
        background-color="transparent"
        color="white"
        style="position: fixed; top: 72px; left: 0; z-index: 6; width: 100%;"
        v-model="tab"
        >
          <v-tab href="#current">{{$t("home.current")}}</v-tab>
          <v-tab href="#history">{{$t("home.completed")}}</v-tab>    
    
        <v-tabs-items v-model="tab" class="flexiapp-tab-item-container">
            <v-tab-item value="current">
                
                <v-row v-if="isLoading" cols="12" justify="center">
                    <v-col class="mx-auto" cols="12">
                        <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%" />
                    </v-col>
                </v-row>
                <v-row v-if="!isLoading && !!errorMessage" justify="center">
                    <v-alert type="info" class="mx-auto col-10" justify="center">{{
                        errorMessage
                     }}</v-alert>
                </v-row>
                <v-row v-if="!isLoading" cols="12" justify="center" class="mx-auto" max-width="90%">
                    <v-card @click="selectOrder(item)" v-for="item in workorders" :key="item.id"
                        class="mx-auto mb-3 card-flexiapps-home"
                        max-width="95%"
                    >
                        <v-card-text>
                            <div class="mb-1 flexiapp-carrier-text">{{item.id}}-{{item.carrier}}</div>
                            <p class="display-1 text--primary title-flexiapps-home mb-1">
                            {{item.bookingId}}
                            </p>
                            <!--<div class="mb-1">{{item.dateReported}}</div>-->
                            <div class="mb-1 flexiapp-count-text"
                            v-bind:style="{ color: compareLinesStatus(item)}">{{calculateLinesStatusSum(item)}}/{{calculateLinesStatusSize(item)}}</div>
                            <v-icon
                                medium
                                color="#EF8F21"
                                class="ml-2 flexiapp-noimage-icon" 
                                v-if="isUploadPending(item)"
                                >mdi-camera-off</v-icon>
                            <div class="flexiapp-date-reported-container">
                                <div class="mb-2">
                                    <span>{{$t('home.maxDateOut')}}</span> 
                                    <span>{{getFormattedDate(item.maxDateOut)}}</span>
                                </div>
                                <div class="mb-2">
                                    <span>{{$t('home.assemblyDate')}}</span>
                                    <span>{{getFormattedDate(item.assemblyDate)}}</span>
                                </div>
                            </div>

                            <!-- Comments --> 
                            <v-divider class="pa-1" v-if="!isEmptyField(item.comment)"></v-divider>
                            <div class="flexiapp-comments-container" v-if="!isEmptyField(item.comment)">
                                <p class="pa-2 pt-1 mb-0 flexiapp-comment-text">{{item.comment}}</p>
                            </div>
                            
                        </v-card-text>
                    </v-card>
                </v-row>
        </v-tab-item>

        <v-tab-item value="history">
                <v-row v-if="isLoading" cols="12" justify="center">
                    <v-col class="mx-auto" cols="12">
                        <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%" />
                    </v-col>
                </v-row>
                <v-row v-if="!isLoading && !!errorMessage" justify="center">
                    <v-alert type="info" class="mx-auto col-10" justify="center">{{
                        errorMessage
                     }}</v-alert>
                </v-row>
                <v-row v-if="!isLoading" cols="12" justify="center" class="mx-auto" max-width="90%">
                    <v-card @click="selectOrder(item)" v-for="item in workorderHistory" :key="item.id"
                        class="mx-auto mb-3 card-flexiapps-home"
                        max-width="95%"
                    >
                        <v-card-text>
                            <div class="mb-1 flexiapp-carrier-text">{{item.id}}-{{item.carrier}}</div>
                            <p class="display-1 text--primary title-flexiapps-home mb-0">
                            {{item.bookingId}}
                            </p>
                            <!--<div class="mb-1">{{item.maxDateOut}}</div>-->
                            <div class="mb-1 flexiapp-count-text"
                            v-bind:style="{ color: compareLinesStatus(item)}">{{calculateLinesStatusSum(item)}}/{{calculateLinesStatusSize(item)}}</div>
                            <v-icon
                                medium
                                color="#EF8F21"
                                class="ml-2 flexiapp-noimage-icon" 
                                v-if="isUploadPending(item)"
                                >mdi-camera-off</v-icon>
                            <div class="flexiapp-date-reported-container">
                                <div class="mb-1">
                                    <span>{{$t('home.maxDateOut')}}</span> 
                                    <span>{{getFormattedDate(item.maxDateOut)}}</span>
                                </div>
                                <div class="mb-1">
                                    <span>{{$t('home.assemblyDate')}}</span>
                                    <span>{{getFormattedDate(item.assemblyDate)}}</span>
                                </div>
                            </div>

                            <!-- Comments --> 
                            <v-divider class="pa-1" v-if="!isEmptyField(item.comment)"></v-divider>
                            <div class="flexiapp-comments-container" v-if="!isEmptyField(item.comment)">
                                <p class="pa-2 pt-1 mb-0 flexiapp-comment-text">{{item.comment}}</p>
                            </div>                      
                            
                        </v-card-text>
                    </v-card>
                </v-row>
        </v-tab-item>
        <v-btn  
         dark 
         fixed 
         bottom 
         right 
         fab 
         color="primary" 
         :loading="isLoading" 
         @click="listarItems()"
        >
           <v-icon dark>mdi-autorenew</v-icon>
        </v-btn>
        </v-tabs-items>

    </v-tabs>

      

  </v-content>

</template>


<script>
// eslint-disable-next-line no-unused-vars
import api from "../../../api/flexiapp";
import BaseModule from "../../common/BaseModule"; 
import discovery from "../../../discovery";

export default {
  name: "HomeMain",
  mixins: [BaseModule],
  components: {},
  data() {
    return {
      tab:null,
      isLoading: false,
      errorMessage: null,
      workorders : [],
      workorderHistory : [],
      version: 'x.x.x',
    };
  },
  computed: {
      employeeId() {
        return this.$store.state.flexiapp.user.userId;
      },
    },
  methods: {
        isUploadPending(item){
            return item.status==4;
        },
        isCompleted(item){
            return item.status==3;
        },
      selectOrder: function (order) {
          this.$router.push({ name: 'order' , params: { id: order.id}});
      },
      listarItems: function () {
      this.errorMessage=null;
      this.workorders = [];
      this.workorderHistory = [];
      this.isLoading = true;

      if(this.employeeId){
        api.getWorkOrders(
            this.employeeId,
            0,
            50,
            discovery.version,
            this.search ? this.search : "",
            null,
            null,
            (data) => {
            this.isLoading = false;
            for (var i in data){
                if(data[i].status != 6){
                    this.workorders.push(data[i])
                }
                else{
                    this.workorderHistory.push(data[i])
                }
            }
            },
            (error) => {
            this.isLoading = false;
            this.errorMessage=error;
            this.$log.error(error); 
            }
        );
      }else{
          this.$router.push({ name: 'login' });
      }
      },
      getFormattedDate(date){
        return date ? this.formatLocalDateTime(new Date(date)) : '';
      },
      calculateLinesStatusSum(workorder){
         var sum = 0;
        for (var i in workorder.workorderLines){
            if(workorder.workorderLines[i].status == 5 || workorder.workorderLines[i].status == 6){
               sum = sum+1;
            }
        }
        return sum;
      },
      calculateLinesStatusSize(workorder){
            return workorder.workorderLines ? workorder.workorderLines.length : 0;
      },
      compareLinesStatus(workorder){
          var sum = this.calculateLinesStatusSum(workorder)
          return this.calculateLinesStatusSize(workorder) == sum && sum >0 ? "green" : "#DA291B";
      },
      isEmptyField(field){
          return field== null  ||  field.length == 0; 
      },
   },
  watch: {
    
  },
  beforeRouteEnter (to, from, next) {
      next(vm => {
          vm.$store.commit('flexiapp/setNavTitle', null);
          vm.listarItems();
          vm.version = discovery.version;
          vm.tab="current"
      })
    }
};
</script>
